import React from 'react';
import { Card, Avatar, Typography, Space } from 'antd';
import { ShareAltOutlined, EyeOutlined } from '@ant-design/icons';

const { Meta } = Card;
const { Text } = Typography;

export default function ArticleCard(props) {
    return (
        <div>
            <Space direction='vertical'>
                <Text>
                    {new Date(props.item.createdAt).toLocaleTimeString()}
                </Text>
                <Card
                    style={{ minWidth: '320px' }}
                    cover={
                        <img alt={props.item.title} src={props.item.image} />
                    }
                    actions={[
                        <ShareAltOutlined key='share' />,
                        <EyeOutlined key='view' />,
                    ]}
                >
                    <Meta
                        avatar={
                            <Avatar src='https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png' />
                        }
                        title={props.item.title}
                        description={props.item.description}
                    />
                </Card>
            </Space>
        </div>
    );
}
